<template>
  <div class="is-flex">
    <p>{{offer_data}}</p>
  </div>
</template>
<script>

export default {
  name: 'OfferBoosterForm',
  props: ['payload'],
  data () {
    return {
      offer_data: 'blank offer data'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.postEvaluateOffer({ offer_id: this.payload.data.id }).then(response => {
        this.offer_data = response
      })
    }
  }
}
</script>
